import EmptyScreen from './empty-screen-view'

export default EmptyScreen
